import React from "react";

function Mobikwik() {
  return (
    <section className="inner-work inner-bx top-sb">
      <div className="container">
        <h2>Mobikwik Cash-PickUp</h2>
        <h4>Mobikwik Cash-PickUp Process</h4>

        <ul>
          <li className="bes-list">
            <figure>
              <img src="/images/image nitish/Matrix/Mobikwik/MobikwikHomes.png" alt="Mobikwik Home" />
            </figure>

            <aside>
              <div className="right-hd">
                <h4>Mobikwik Cash-PickUp Home</h4>
              </div>

              <figure>
                <img src="/images/image nitish/Matrix/Mobikwik/MobikwikHome6.png" alt="" />
              </figure>

              <figure>
                <img src="/images/image nitish/Matrix/Mobikwik/MobikwikHome4.png" alt="" />
              </figure>
            </aside>
          </li>

          <li className="bes-list">
            <aside>
              <div className="right-hd">
                <h4>Mobikwik Cash-PickUp Field Screen</h4>
              </div>

              <figure>
                <img src="/images/image nitish/Matrix/Mobikwik/MobikwikHomeScreen.png" alt="" />
              </figure>
            </aside>

            <figure>
              <img src="/images/image nitish/Matrix/Mobikwik/MobikwikHomeScreen.png" alt="" />
            </figure>
          </li>

          <li className="bes-list">
            <figure>
              <img src="/images/image nitish/Matrix/Mobikwik/MobikwikHomeReport.png" alt="" />
            </figure>

            <aside>
              <div className="right-hd">
                <h4>Mobikwik Cash-PickUp Reports</h4>
              </div>

              <figure>
                <img src="/images/image nitish/Matrix/Mobikwik/MobikwikHome1.png" alt="" />
              </figure>

              <figure>
                <img src="/images/image nitish/Matrix/Mobikwik/MobikwikHome5.png" alt="" />
              </figure>
            </aside>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Mobikwik;